module.exports = __webpack_public_path__ + "static/media/clean_demo_image.fa189844.png";